import { Component, OnInit } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'page-maintain',
    templateUrl: 'maintain.html',
})
export class MaintainPage {
    maintain;
    maintainContent;
    constructor(
        private navParam: NavParams,
        private sanitizer: DomSanitizer
    ) {
        this.maintain = this.navParam.data['maintainInfo'];
        console.log("ssss",this.maintain);
        this.maintainContent = this.sanitizer.bypassSecurityTrustHtml(this.maintain.Content);
    }
    ionViewDidLoad() {
        // this.maintain = this.navParam.data['maintainInfo'];
        // console.log(this.maintain);
    }
}



// WEBPACK FOOTER //
// ./src/pages/maintain/maintain.ts